import { render, staticRenderFns } from "./NewCategoryDialog.vue?vue&type=template&id=175007ea"
import script from "./NewCategoryDialog.vue?vue&type=script&lang=js"
export * from "./NewCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports